export class Country {
  hierarchyCode?: string;
  name!: string;
  countryIsoNumericCode!: string;
}
